// extracted by mini-css-extract-plugin
module.exports = {"dropOuterBox":"DescribeIt_dropOuterBox__3KxIh","dropArea":"DescribeIt_dropArea__1t6ag","dropInnerContainer":"DescribeIt_dropInnerContainer__2mo4r"};